const styles = () => ({
  dialogPaper: {
    borderRadius: 8,
    overflow: 'visible',
    width: '80%',
    height: 'auto',
  },
  expressionBox: {
    position: 'absolute',
    width: '100%',
    left: '50%',
    transform: 'translate(-50%,-100%)',
    maxWidth: 600,

    '& img': {
      display: 'block',
      width: '100%',
    },
  },
});

export default styles;
